import { getFramework } from '@/framework';
import type { ReferenceLine } from '@/version-types';
import { getReferenceLinesState } from '../states/reference-lines-state';
import { ReferenceLineHistoryType } from '../types';

export class UpdateReferenceLine {
    constructor(private id: string) {}

    update(newLine: ReferenceLine, oldLine?: ReferenceLine, pushHistory = true) {
        const roundedNewLine = {
            ...newLine,
            position: Math.round(newLine.position),
        };

        getReferenceLinesState(this.id).updateReferenceLine(roundedNewLine);

        // 写入历史记录
        if (pushHistory && oldLine) {
            const framework = getFramework(this.id);
            framework.history.write({
                type: ReferenceLineHistoryType.UPDATE,
                data: {
                    oldInfo: oldLine,
                    newInfo: roundedNewLine,
                },
            });
        }
    }
}
